import { PublicLayout } from "@/components/layout/PublicLayout";
import { ShieldCheck, Eye, ToggleRight, Compass } from "lucide-react";

const values = [
  {
    icon: Eye,
    title: "No dark patterns",
    body: "We never hide marketing consent under a 'see your results' button. What you're agreeing to is always front and center.",
  },
  {
    icon: ToggleRight,
    title: "Channel by channel",
    body: "Email and SMS are separate choices. Opt into one, both, or neither — you're always in control of how we reach you.",
  },
  {
    icon: ShieldCheck,
    title: "Consent on record",
    body: "For every submission we store exactly what you agreed to, when, and from where — so consent is clear and documented.",
  },
  {
    icon: Compass,
    title: "Helpful, not pushy",
    body: "We send relevant information, resources, and available options based on the goal you chose. Nothing more.",
  },
];

export default function About() {
  return (
    <PublicLayout>
      <div className="mx-auto max-w-7xl px-6 py-16 md:py-24 lg:px-8" data-testid="about-page">
        <div className="max-w-2xl">
          <p className="font-body text-xs font-semibold uppercase tracking-[0.2em] text-primary">
            About Step Zone
          </p>
          <h1 className="mt-3 font-heading text-4xl font-bold tracking-tighter text-foreground sm:text-5xl">
            Consent, done right.
          </h1>
          <p className="mt-6 font-body text-base leading-relaxed text-muted-foreground md:text-lg">
            Step Zone helps people take their next financial step — lowering
            expenses, finding financing, improving credit, building savings, or
            exploring insurance. You tell us your goal, we send relevant
            resources, and you decide exactly how you'd like to hear from us.
          </p>
          <p className="mt-4 font-body leading-relaxed text-muted-foreground">
            We built it around one belief: getting help shouldn't mean giving up
            control. That's why our whole flow is transparent, and every consent
            choice is explicit and separate.
          </p>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v) => (
            <div
              key={v.title}
              className="rounded-2xl border border-border bg-card p-6 transition-transform duration-200 hover:-translate-y-1"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10 text-primary">
                <v.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold tracking-tight text-foreground">
                {v.title}
              </h3>
              <p className="mt-2 font-body text-sm leading-relaxed text-muted-foreground">{v.body}</p>
            </div>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
}
